import * as React from 'react';
import type { SVGProps } from 'react';
const SvgHomeDropdown = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={12}
    height={14}
    fill="currentColor"
    viewBox="0 0 12 14"
    {...props}
  >
    <path
      fill="#999"
      d="M1.5 12.125h2v-4.25q0-.319.216-.534a.73.73 0 0 1 .534-.216h3.5q.319 0 .534.216a.73.73 0 0 1 .216.534v4.25h2v-7.25L6 1.5 1.5 4.875zm-1.5-.25v-7q0-.351.156-.665t.448-.543l4.5-3.375Q5.521 0 6 0t.896.292l4.5 3.375q.291.229.448.543.156.314.156.665v7q0 .721-.514 1.236a1.69 1.69 0 0 1-1.236.514h-2.5a.73.73 0 0 1-.534-.216.73.73 0 0 1-.216-.534v-4.25H5v4.25q0 .319-.216.534a.73.73 0 0 1-.534.216h-2.5q-.721 0-1.236-.514A1.69 1.69 0 0 1 0 11.875"
    />
  </svg>
);
export default SvgHomeDropdown;
